import { IProductGroup } from '@alberta/konexi-shared';
import { TenantConfigService } from '@services/tenant-config/tenant-config.service';
import { ProductGroupDB } from 'src/app/common/repository/databases';
import { PrescriptionNodeValue } from 'src/app/shared/models/prescription/prescription-node-value.model';
import { PrescriptionRequestDto } from 'src/app/shared/models/prescription/prescription-request-dto.model';
import { QueryService } from 'src/app/shared/services/query/query.service';

import { PrescriptionChainHandler } from './prescription-chain-handler';

export class MedicalAidHandler extends PrescriptionChainHandler {
  constructor(private _queryService: QueryService, private _tenantConfigService: TenantConfigService) {
    super();
  }

  async handleRequest(prescriptionRequestDto: PrescriptionRequestDto, request: PrescriptionNodeValue) {
    /**
     * normally medical aid prescription should only display productGroup information
     * some clients want to keep article information
     * flag displayMedicalAidArticleNameOnPrescription is used to control this behaviour
     */
    const displayMedicalAidArticleName = await this._tenantConfigService.displayMedicalAidArticleNameOnPrescription();
    if (!displayMedicalAidArticleName) {
      for (const prescription of prescriptionRequestDto.prescriptions) {
        if (prescription.medicalAidPrescription) {
          const productGroupIds = [
            ...new Set(
              prescription.positions
                .filter(position => position?.productGroupId)
                .map(position => position.productGroupId)
            ),
          ];
          if (productGroupIds?.length) {
            const twgs = await this._queryService.search<IProductGroup>(
              { query: productGroupIds.map(id => `_id:${id}`).join(' ') },
              ProductGroupDB,
              { isIn: true }
            );
            prescription.positions.forEach(position => {
              const productGroup = twgs.find(item => item._id === position.productGroupId);
              if (productGroup) {
                position.name = productGroup.name;
                position.applienceNo = productGroup.medicalAidPositionNumber?.toString();
                position.pcnNo = null;
                position.articleId = null;
                position.description = null;
              }
            });
          }
        }
      }
    }
    return this.next.handleRequest(prescriptionRequestDto, request);
  }
}
